// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {LocalizationContainer} from 'us-i18n';
import {getAppStore} from './store';
import 'modules/common/style/index.less';
import {LoginContainer} from 'modules/auth/containers/LoginContainer';
import {extraArgs} from 'app/store/extra-args-anonymous.js';

const root = document.getElementById('root');

if (!root) {
    throw Error('Cannot find #root');
}
const store = getAppStore({extraArgs});

ReactDOM.render(
    <Provider store={store}>
        <LocalizationContainer>
            <LoginContainer />
        </LocalizationContainer>
    </Provider>,
    root
);
